const IN_VIEW_CLASS = 'is-in-view';

class InView {
  constructor() {
    this.elements = document.querySelectorAll('.js-in-view');

    // IE check.
    if (typeof IntersectionObserver !== 'function') {
      this.elements.forEach(el => el.classList.add(IN_VIEW_CLASS));
      return;
    }

    this.initInView();
  }

  handleIntersection(entries) {
    entries.map(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add(IN_VIEW_CLASS);
      }
    });
  }

  initInView() {
    const options = {
      rootMargin: '-100px',
    };

    const observer = new IntersectionObserver(this.handleIntersection, options);

    this.elements.forEach(element => observer.observe(element));
  }
}

export default InView;
